import { MechanicalEstimateBuilder } from './../builders/mechanical-estimate-builder';
import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class MechanicalEstimateApiService {
    constructor(api) {
        this.api = api;
    }
    createMechanicalEstimate(params) {
        return this.api.post(`/mechanicalestimate/create`, JSON.stringify(params)).toPromise()
            .then(response => MechanicalEstimateBuilder.buildMechanicalEstimate(response.mechanical_estimate));
    }
    addCarServiceEstimate(id_mechanical_estimate, params) {
        return this.api.post(`/mechanicalestimate/add_car_service_estimate/${id_mechanical_estimate}`, JSON.stringify(params)).toPromise()
            .then(response => MechanicalEstimateBuilder.buildMechanicalEstimate(response.mechanical_estimate));
    }
    deleteCarServiceEstimate(id_mechanical_estimate, params) {
        return this.api.post(`/mechanicalestimate/delete_car_service_estimate/${id_mechanical_estimate}`, JSON.stringify(params)).toPromise()
            .then(response => MechanicalEstimateBuilder.buildMechanicalEstimate(response.mechanical_estimate));
    }
}
MechanicalEstimateApiService.ɵfac = function MechanicalEstimateApiService_Factory(t) { return new (t || MechanicalEstimateApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
MechanicalEstimateApiService.ɵprov = i0.ɵɵdefineInjectable({ token: MechanicalEstimateApiService, factory: MechanicalEstimateApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(MechanicalEstimateApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=mechanical-estimate-api.service.js.map